import { Injectable } from '@angular/core';
import {OverlayService} from "../overlay/overlay.service";
import {CodeInputComponent} from "../shared/code-input/code-input.component";

@Injectable({
  providedIn: 'root'
})
export class CodeInputService {

  constructor(private overlayService: OverlayService) { }

  openCodeInputService(params: {title?: string, pattern?: string, submitButtonLabel?: string, submitCallback?: (code: string) => void}): void {
    if(!('title' in params)) {
      params.title = "";
    }
    if(!('pattern' in params)) {
      params.pattern = "";
    }
    if(!('submitCallback' in params)) {
    }


    const componentData = {
      title: params.title ?? "",
      pattern: params.pattern ?? "",
      submitCallback: params.submitCallback ?? null,
      submitButtonLabel: params.submitButtonLabel ?? ""
    };

    this.overlayService.openWindowOverlay({
      componentMain: {
        component: CodeInputComponent,
        data: componentData
      }
    })

  }
}
